import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import SignIn from "../auth/SignIn";
import ForgotPassword from "../auth/ForgotPassword";
import ChangePassword from "../auth/ChangePassword";

// AuthRoutes should ONLY handle unauthenticated routes
export default function AuthRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<SignIn />} />
      <Route path="/forgotPassword" element={<ForgotPassword />} />
      <Route path="/changePassword/:token" element={<ChangePassword />} />

      {/* Redirect root to login */}
      <Route path="/" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
